import {action, observable} from "mobx";
import {deepObserve} from "mobx-utils";

export const createArray = () => Array(53).fill().map(() => Array(7).fill(0));

class GraphStore {
    constructor() {
        this.load();
        deepObserve(this, () => this.save());
    }

    load() {
        let json = localStorage.getItem('store');
        if (json) {
            Object.assign(this, JSON.parse(json));
        }
    }

    save() {
        localStorage.setItem('store', JSON.stringify(this));
    }

    @action
    reset() {
        this.m = createArray();
    }


    @observable m = createArray();
}

export default new GraphStore();